<div class="row d-flex align-items-center justify-content-between flex-wrap">
    <!-- <div class="col-6 pd-l-10px"> -->
    <div class="col d-flex align-items-center" style="padding : 0px 0px 0px 20px">
        <h2 mat-dialog-title class="text-capitalize">view previous info</h2>
    </div>
    <!-- <div class="d-flex align-items-center col-6 justify-content-end"> -->
    <div class="d-flex col-8 align-items-center flex-wrap justify-content-end">
        <div style="padding: 0px 10px 0px 10px;">
            <button mat-raised-button color="primary" (click) = "toggleToLinkMeeting.emit()">Go To Link Meeting</button>
        </div>
        <div>
            <app-common-button-toggler (buttonTogglerEvent)="buttonTogglerEvent($event)"></app-common-button-toggler>
        </div>
        <!-- <div style="padding: 0px 10px 0px 10px;">
            <app-common-search-field (searchEvent) = "searchEvent($event)"></app-common-search-field>
        </div> -->
        <div>
            <button mat-icon-button (click) = "removePane.emit()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

</div>
<mat-divider></mat-divider>
<div dialog-content-container>
    <div style="height: calc(100vh - 211px);overflow-y: auto;">
        <cdk-accordion class="example-accordion" multi = "true">
            <cdk-accordion-item 
              *ngFor = "let items of agendaArrayContainer; let index = index"  
              expanded = "false"
              #accordionItem="cdkAccordionItem"
              class="example-accordion-item overallagenda_div"
    
              tabindex="0"
              [attr.id]="'accordion-header-' + index"
              [attr.aria-expanded]="accordionItem.expanded"
              [attr.aria-controls]="'accordion-body-' + index"
              
              >
              <div class="d-flex" style="padding: 10px 0px 0px 0px;" *ngIf="items.agendaList[0]">
                <div class="d-flex col-md-12 align-items-start">
                    <mat-icon (click)="accordionItem.toggle();accordionItem.expanded?fetchAgendaMinutesList(index,items.agendaList[0]):''">{{ accordionItem.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon>
                    <div>
                        <h3 class="margin-0 body-font-size f-weight agendaTitle">{{items.agendaList[0].agendaTitle}} - {{items.meetingTitle}} held on {{items.meetingDateStr}} at {{items.meetingStartTime}} {{items.tzName}}</h3>
                    </div>
                </div>
              </div>
              <div
                class="example-accordion-item-body col-md-11"
                role="region"
                [style.display]="accordionItem.expanded ? '' : 'none'"
                *ngIf="items.agendaList[0]"
                >
                <div>
                    <mat-list class="col-md-12">
                        <mat-list-item class="height-0" *ngFor = "let minItems of items.agendaList[0].minutesList">
                            <ng-container *ngIf="(((minItems.entityType=='MN' && minItems.isPrivate!='Y') || (minItems.entityType=='MN' && minItems.isPrivate=='Y' && minItems.createdBy==loggedInUser)) && noteChecker) ">                  
                                <div class="d-flex">
                                    <div class="d-flex col-md-12 align-items-center">
                                        <div>        
                                            <button class="global-icn-bttn-containers mat-margin-3px" mat-mini-fab tooltip = "Notes" triggers = "hover"><mat-icon class ="global-icn-size notes">notes</mat-icon></button>
                                        </div>
                                        <div>        
                                            <h4 class="acc-content body-font-size margin-0" [innerHtml]="minItems.noteDescription"></h4>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="(((minItems.entityType=='MD' && minItems.isPrivate!='Y') || (minItems.entityType=='MD' && minItems.isPrivate=='Y' && minItems.createdBy==loggedInUser)) && decisionChecker) ">
                                <div class="d-flex">
                                    <div class="d-flex col-md-12 align-minItems-center">
                                        <div>        
                                            <button  class="mat-margin-3px global-icn-bttn-containers hide" mat-mini-fab tooltip = "Decision" triggers = "hover"><mat-icon class = "global-icn-size decision">thumb_up</mat-icon></button>
                                        </div>
                                        <div>        
                                            <h4 class="acc-content body-font-size margin-0" [innerHtml]="minItems.noteDescription"></h4>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="(((minItems.entityType=='AI' && minItems.isPrivate!='Y') || (minItems.entityType=='AI' && minItems.isPrivate=='Y' && minItems.createdBy==loggedInUser)) && taskChecker)">                      
                                <div class="d-flex">
                                    <div class="d-flex col-md-12 align-items-center">
                                        <div>        
                                            <button class="mat-margin-3px global-icn-bttn-containers" mat-mini-fab tooltip = "Task" triggers = "hover"><mat-icon class = "global-icn-size assignment">assignment</mat-icon></button>
                                        </div>
                                        <div>        
                                            <h4 class="acc-content body-font-size margin-0" [innerHtml]="minItems.taskTitle"></h4>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </mat-list-item>
                        <ng-container *ngIf="items.agendaList[0]!.minutesList!=null && items.agendaList[0]!.minutesList!.length==0">
                            <div class="d-flex align-items-center">No Data Found</div>
                        </ng-container>
                    </mat-list>
                        <!-- Recursive rendering of subtopics -->
                        <ng-container *ngTemplateOutlet="renderSubtopics; context: { $implicit: items.agendaList[0].subtopics }"></ng-container>
                     </div>
            
                <ng-template #renderSubtopics let-subtopics>
                    <ng-container *ngFor="let subtopic of subtopics">       
                      <div class="subtopic" style="margin-left: 16px;">
                        <cdk-accordion class="example-accordion" multi = "true">
                            <cdk-accordion-item 
                              expanded = "false"
                              #accordionItem="cdkAccordionItem"
                              class="example-accordion-item overallagenda_div"
                    
                              tabindex="0"
                              [attr.id]="'accordion-header-' + index"
                              [attr.aria-expanded]="accordionItem.expanded"
                              [attr.aria-controls]="'accordion-body-' + index"
                              
                              >
                              <div class="d-flex" style="padding: 10px 0px 0px 0px;" >
                                <div class="d-flex col-md-12 align-items-start">
                                    <mat-icon (click)="accordionItem.toggle();">{{ accordionItem.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon>
                                    <div>
                                        <h3 class="margin-0 body-font-size f-weight agendaTitle">{{ subtopic.agendaTitle }}</h3>
                                    </div>
                                </div>
                              </div>
                              <div
                                class="example-accordion-item-body col-md-11"
                                role="region"
                                [style.display]="accordionItem.expanded ? '' : 'none'"
                               
                                >

                                <mat-list>
                                    <mat-list-item *ngFor="let minute of subtopic.minutesList">
              
                                      <ng-container *ngIf="(((minute.entityType=='MN' && minute.isPrivate!='Y') || (minute.entityType=='MN' && minute.isPrivate=='Y' && minute.createdBy==loggedInUser)) && noteChecker) ">                  
                                          <div class="d-flex">
                                              <div class="d-flex col-md-12 align-items-center">
                                                  <div>        
                                                      <button class="global-icn-bttn-containers mat-margin-3px" mat-mini-fab tooltip = "Notes" triggers = "hover"><mat-icon class ="global-icn-size notes">notes</mat-icon></button>
                                                  </div>
                                                  <div>        
                                                      <h4 class="acc-content body-font-size margin-0" [innerHtml]="minute.noteDescription"></h4>
                                                  </div>
                                              </div>
                                          </div>
                                      </ng-container>
                                      <div *ngIf="minute.entityType === 'AI'">
                                        <h5>{{ minute.taskTitle }}</h5>
                                      </div>
                                    </mat-list-item>
                                  </mat-list>
                              </div>
                            </cdk-accordion-item>
                        </cdk-accordion>
                        <!-- <div class="acc-content body-font-size margin-0">{{ subtopic.agendaTitle }}</div> -->

                        <!-- Render minutes for current subtopic -->
                        
                        
                        <!-- Recursively render subsubtopics -->
                        <ng-container *ngTemplateOutlet="renderSubtopics; context: { $implicit: subtopic.subtopics }"></ng-container>
                        
                      </div>
                    </ng-container>
                  </ng-template>
                <!-- <div *ngIf = "item.minutesList.length == 0">
                    <h3 class="margin-0 body-font-size" style="margin-left: 45px !important;"></h3>
                </div> -->
              </div>
            </cdk-accordion-item>
        </cdk-accordion>
        <ng-container *ngIf="agendaArrayContainer!=null && agendaArrayContainer!.length==0">
            <div [ngStyle]='sideNav.dialogCheckedEmitter() == false ? {"height": "calc(100vh - 193px)","width": "100%","overflow-y": "auto"} : {"height": "calc(100vh - 100px)","width": "100%","overflow-y": "auto"}' class="d-flex p4-ssection justify-content-center" style="padding-top: 160px;font-size: 1.5rem;">No Data Found</div>
        </ng-container>
    </div>
</div>
<div class="progress-indicator">
    <mat-progress-spinner mode="indeterminate" [diameter]="50"  *ngIf="spinner" bdColor="rgba(51,51,51,0.8)"></mat-progress-spinner>
</div>
<div mat-dialog-actions>
    <!-- <mat-paginator [length]="100"
          [pageSize]="10"
          [pageSizeOptions]="[5, 10, 25, 100]"
          aria-label="Select page">
    </mat-paginator> -->
    <mat-paginator #viewPrevAgPaginator [hidePageSize]="true"  [pageSize]="10" (page)="fetchPrevAgendaHis()" >
        aria-label="Select page">
    </mat-paginator>
</div>
